<div class="title-divider-print-buttons mt-md-2">
  <h1>{{ "forbidden.title" | translate }}</h1>
</div>

<p class="lead">
  <span>{{ "forbidden.text" | translate }}</span
  ><br />
  <span>{{ "security.adminHint" | translate }}</span>
</p>

<span>{{ "security.actionUrl" | translate }}</span>
<ul>
  <li>{{ securityData.actionUrl }}</li>
</ul>
